var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-file',_vm._g(_vm._b({class:{ ..._vm.customInputClasses }},'b-form-file',{
        ..._vm.$attrs,
        ..._vm.$props,
        value: _vm.innateValue,
        placeholder: _vm.$_(_vm.placeholder),
        accept: _vm.contentType,
    },false),{
        ..._vm.$listeners,
        input: ($event) => (_vm.innateValue = $event),
    }))
}
var staticRenderFns = []

export { render, staticRenderFns }